import PropTypes from 'prop-types';

import React, {
    useEffect,
    useState
} from 'react';

import {
    Map,
    MapCanvas,
    MapControls
} from '$partials/base/index.js';

import { JobItem } from '$partials/listings/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleJobMap = ({ items = null }) => {
    // state
    const [ markerActive, setMarkerActive ] = useState(null);
    const [ itemLocations, setItemLocations ] = useState([]);

    // methods
    const handleNext = () => {
        if (markerActive) {
            setMarkerActive(markerActive.next);
        }
    };

    const handlePrev = () => {
        if (markerActive) {
            setMarkerActive(markerActive.previous);
        }
    };

    // hooks
    useEffect(() => {
        const locations = items?.map((item) => {
            if (!item.node) {
                return null;
            }

            return {
                id: item.node.id,
                lat: item.node.locationLat,
                lng: item.node.locationLng
            };
        }).filter(Boolean);

        setItemLocations(locations);
    }, [ items ]);

    // render
    return (
        <div className='relative'>
            {itemLocations.length > 0 && (
                <Map
                    locations={itemLocations}
                    markerActive={markerActive}
                    setMarkerActive={setMarkerActive}>
                    <MapCanvas />
                    <MapControls />
                </Map>
            )}

            {markerActive?.id && (
                <div className='md:absolute md:top-0 md:left-0 md:mt-60 md:w-full md:pointer-events-none'>
                    <div className='md:layout-container'>
                        <div className='md:layout-grid-negative-gutter'>
                            <div className='md:flex md:flex-wrap'>
                                <div className='md:w-1/12' />

                                <div className='md:w-4/12 px-20 sm:px-40 md:px-30 md:-mx-15 bg-white md:pointer-events-auto'>
                                    {items.filter(item => item.node.id === markerActive.id).map((item, idx) => {
                                        return (
                                            <JobItem
                                                handleClose={setMarkerActive.bind(this, null)}
                                                handleNext={handleNext.bind(this)}
                                                handlePrev={handlePrev.bind(this)}
                                                key={idx}
                                                mapModule={true}
                                                {...item.node} />
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = { items: PropTypes.array.isRequired };

ModuleJobMap.propTypes = propTypes;

export default ModuleJobMap;
